
<div class="offline-warning-panel">
  <div class="offline-warning-panel-component hidden" @click="close">
    <div class="component-background" @click="close" />
    <slide-y-up-transition :duration="1000">
      <div v-show="show" class="wrapper" :class="$store.state.theme">
        <div class="is-flex">
          <!-- <button class="delete is-medium close" /> -->
          <p style="flex-shrink: 1; margin-right: 20px">
            <img src="/img/home2/no-wifi.svg" />
          </p>
          <p class="is-size-5" style="flex: 1">{{ $t("offline") }}</p>
        </div>
      </div>
    </slide-y-up-transition>
  </div>
</div>
